/**
 * Conference Responses endpoints: the pivot read + single-cell edit/delete.
 * super_admin always names the target tenant (operate-as-tenant scope), so
 * `companyId` is required and appended as `?companyId=`.
 */
import { superadminFetch } from './dataProvider';
import type { ConferenceResponsesResponse } from './discoveryTypes';

function scope(companyId: string): string {
  return `?companyId=${encodeURIComponent(companyId)}`;
}

export function fetchConferenceResponses(
  conferenceId: string,
  companyId: string,
): Promise<ConferenceResponsesResponse> {
  return superadminFetch<ConferenceResponsesResponse>(
    `/v1/superadmin/conferences/${conferenceId}/responses${scope(companyId)}`,
  );
}

export interface UpdateResponseBody {
  freeText?: string | null;
  selectedOptionIds?: string[];
}

export function updateConferenceResponse(
  conferenceId: string,
  personId: string,
  questionId: string,
  body: UpdateResponseBody,
  companyId: string,
): Promise<void> {
  return superadminFetch<void>(
    `/v1/superadmin/conferences/${conferenceId}/responses/${personId}/${questionId}${scope(companyId)}`,
    { method: 'PATCH', body: JSON.stringify(body) },
  );
}

export function deleteConferenceResponse(
  conferenceId: string,
  personId: string,
  questionId: string,
  companyId: string,
): Promise<void> {
  return superadminFetch<void>(
    `/v1/superadmin/conferences/${conferenceId}/responses/${personId}/${questionId}${scope(companyId)}`,
    { method: 'DELETE' },
  );
}
